export interface Orderable {
  order: number;
}

export const sortByOrder = (a: Orderable, b: Orderable): number => a.order - b.order;
